import Nodizurc from "views/Nodizurc/Nodizurc.jsx";

var indexRoutes = [
  { path: "/", name: "Nodizurc", component: Nodizurc }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx